import { useState } from "react";
import CaseTransferHome from "./CaseTransferHome";

const CaseTransferParentHome = () => {
  const [relatedLink, setRelatedLink] = useState("CaseTransfer");

  return (
    <div className="container-fluid">
      <div className="row">
        {/* Left Side Tabs */}
        <div className="col-12 col-sm-12 col-md-12 col-lg-4 p-0">
          <ul
            className="nav toptab-two mb-3"
            id="v-pills-tab"
            role="tablist"
            aria-label="Case Transfer Tabs"
          >
            <li className="nav-item">
              <a
                role="tab"
                id="case-transfer-tab"
                aria-controls="case-transfer-panel"
                aria-selected={relatedLink === "CaseTransfer"}
                className={
                  relatedLink === "CaseTransfer"
                    ? "nav-link active"
                    : "nav-link"
                }
                data-toggle="pill"
                onClick={() => setRelatedLink("CaseTransfer")}
                href="#case-transfer-panel"
              >
                Case Transfer
              </a>
            </li>
          </ul>
        </div>

        {/* Right Side Content */}
        <div className="col-12 col-sm-12 col-md-12 col-lg-8 pr-0">
          <div className="tab-content tab-form" id="v-pills-tabContent">
            {relatedLink === "CaseTransfer" && (
              <div
                className="tab-pane fade show active"
                id="case-transfer-panel"
                role="tabpanel"
                aria-labelledby="case-transfer-tab"
              >
                <CaseTransferHome />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaseTransferParentHome;
